module.exports = "<div class=\"pdf--container\">\n\t<pdf-viewer [src]=\"url\"\n\t            [original-size]=\"false\"\n\t            [zoom]=\"zoom\"\n\t            [autoresize]=\"true\"\n\t            style=\"max-width: 550px; display: block; max-height: 600px; overflow-y: scroll;\">\n    </pdf-viewer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/hippa-pdf/hippa-pdf.component.html
// module id = ./src/app/shared/components/hippa-pdf/hippa-pdf.component.html
// module chunks = main